import { useEffect, useRef, useState } from "react";
import { ReactComponent as DownBracket } from "../Images/down_bracket.svg";
import { ReactComponent as DropdownPolygon } from "../Images/dropdown_polygon.svg";

import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const DropdownOption = ({
  title,
  dropdown_list,
  width,
  optionChange,
  page = "",
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const [_title, set_Title] = useState(title);
  const clickRef = useRef(null);

  const handleClick = () => {
    setIsClicked(!isClicked);
  };
  const handleClickOutside = (e) => {
    if (clickRef.current && !clickRef.current.contains(e.target)) {
      setIsClicked(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = ({ data }) => {
    let selectedOption = data;
    optionChange(selectedOption);
    set_Title(selectedOption);
  };
  return (
    <div ref={clickRef}>
      <div
        className="dropdownBtn"
        style={{
          boxShadow: isClicked
            ? "0 0 0 1px #1167ed inset"
            : page === "refund"
            ? "inset 0 0 0 1px #b0b0b0"
            : "",
          marginRight: "8px",
          width: width,
        }}
        onClick={handleClick}
      >
        <div className="dropdownBtn_text">{_title}</div>
        {page === "refund" ? (
          <DropdownPolygon
            style={{
              transform: isClicked ? "rotate(180deg)" : "",
              marginLeft: "auto",
              marginRight: "15px",
            }}
          />
        ) : (
          <DownBracket
            stroke="#888888"
            style={{ transform: isClicked ? "rotate(180deg)" : "" }}
          />
        )}
      </div>
      {isClicked ? (
        <div
          className="dropdownOptionBox"
          style={{ width: width, boxSizing: page === "refund" && "border-box" }}
        >
          <div
            className="dropdownOption"
            onClick={() => {
              handleOptionClick(title);
              set_Title(title);
              handleClick();
            }}
          >
            <div
              className="dropdownOption_text"
              style={{ color: _title === title ? "#1167ed" : "#000000" }}
            >
              {title}
            </div>
          </div>
          {dropdown_list.map((data) => (
            <div
              key={data}
              className="dropdownOption"
              style={{
                width: "auto",
                color: _title === data ? "#1167ed" : "#000000",
              }}
              onClick={() => {
                handleOptionClick({ data });
                handleClick();
              }}
            >
              <div className="dropdownOption_text">{data}</div>
            </div>
          ))}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default DropdownOption;
